import { getV1Currency, postV1Parties } from "@/api-client/api.accounting/api";
import { getV1InventoryItems, getV1WarehouseLocation } from "@/api-client/api.inventory/api";
import { LabelKeyFunction } from "@/types";
import { getToken } from "@/utils";
import { createAsyncThunk } from "@reduxjs/toolkit";
import _ from "lodash";

// Stub implementation for Redux actions - consuming applications should provide their own implementation
export const createParties = createAsyncThunk(
  "parties/create",
  async (payload: any) => {
    const response = await postV1Parties({
      ...payload,
      ...getToken(),
    });
    return response;
  }
);
export const getOptions = async (
  apiFunc: any,
  filters: any,
  dataKey: string,
  labelKey: string | LabelKeyFunction,
  valueKey?: any
) => {
  const response = await apiFunc({
    ...filters,
    ...getToken(),
  });

  const options: any[] =
    response?.data?.[dataKey]?.map((d) => ({
      ...d,
      label: labelKey instanceof Function ? labelKey(d) : _.get(d, labelKey),
      value: valueKey ? _.get(d, valueKey, d.id) : d.id,
    })) || [];
  return options;
};

export const getLocation = createAsyncThunk(
  "location/fetch",
  async (filter: any) => {
    const locationFilter = {
      ...filter,
    };
    const response = await getOptions(
      getV1WarehouseLocation,
      locationFilter,
      "warehouseLocationList",
      "name"
    );
    return response;
  }
);

export const getItems = createAsyncThunk("item/fetch", async (filter: any) => {
  const itemFilter = {
    ...filter,
    order: "name:1",
    // select:"[id,name,type,unit_of_measurement,default_tax_id,vendor_informatio]"
  };
  const response = await getOptions(
    getV1InventoryItems,
    itemFilter,
    "inventoryItemsList",
    "name"
  );
  return response;
});

export const getCurrency = createAsyncThunk(
  "currency/fetch",
  async (filter: any) => {
    const currencyFiter = {
      ...filter,
    };
    const response = await getOptions(
      getV1Currency,
      currencyFiter,
      "currencies",
      "currency_name"
    );
    return response;
  }
);